export default {
  // PlanEntitlements
  'company_entitlements.title': 'Plan Entitlements',
  'company_entitlements.limit.agents.label': 'Agents',
  'company_entitlements.limit.services.label': 'Services',
  'company_entitlements.limit.teams.label': 'Teams',
  'company_entitlements.limit.targets.label': 'Targets',
  'company_entitlements.limit.users.label': 'Users',
  'company_entitlements.date_start.label': 'Date start',
  'company_entitlements.date_end.label': 'Date end',
  'company_entitlements.tracking_period_message.limit_unique': 'unique',
  'company_entitlements.tracking_period_message.target': 'target',
  'company_entitlements.tracking_period_message.targets': 'targets',
  'company_entitlements.tracking_period_message.per_month': 'per month',
  'company_entitlements.tracking_period_message.per_week': 'per week',
  'company_entitlements.tracking_period_message.per_day': 'per day',

  // UsageChart
  'company_entitlements.usage_chart.strategy.agent.chart_name': 'Agent Usage',
  'company_entitlements.usage_chart.strategy.targets.chart_name':
    'Unique target usage',
  'company_entitlements.usage_chart.strategy.label.hosts': 'Hosts',
  'company_entitlements.usage_chart.strategy.label.containers': 'Containers',
  'company_entitlements.usage_chart.strategy.label.applications':
    'Applications',
  'company_entitlements.usage_chart.strategy.label.host_targets':
    'Host Targets',
  'company_entitlements.usage_chart.strategy.label.container_targets':
    'Container Targets',
  'company_entitlements.usage_chart.no_data_message':
    'No usage data for selected time period',
  'company_entitlements.usage_chart.error_loading_message':
    'Could not fetch data for selected time period'
}
